import { Map } from 'immutable';
import reducerChain from '../helpers/chain';
import Constants from '../../constants/index';
import { commonReducerCreator } from '../helpers/index';

export const DEFAULT_STATE = Map({});

const topicQuery = commonReducerCreator(Constants.QUERY_TOPIC, true);

function topicQueryClear(state, action) {
	const { type } = action;
	switch (type) {
		case Constants.QUERY_TOPIC_CLEAR:
			return Map();
		default:
			return state;
	}
}

export default reducerChain([topicQuery, topicQueryClear], DEFAULT_STATE);
